<!DOCTYPE html>
<html lang="en">
<meta http-equiv="content-type" content="text/html;charset=utf-8" />

<head>
   <meta charset="utf-8" />
   <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
   <title>TANUVAS</title>
   <meta content='width=device-width, initial-scale=1.0, shrink-to-fit=no' name='viewport' />
   <!--  Social tags  -->
   <meta name="keywords" content="">
   <meta name="description" content="">
   <!--     Fonts and icons     -->
</head>

<body class="off-canvas-sidebar tanuvas">
   <div class="container_fluid">
      <div class="row">
         <div class="col-lg-2 col-sm-2 col-12">
            <img src="assets/images/Group_1291.png" alt="" class="img-fluid" />
         </div>
         <div class="col-lg-10 col-sm-10 col-12">
            <h3>TAMIL NADU VETERINARY AND ANIMAL SCIENCES UNIVERSITY</h3>
            <p>Madhavaram Milk Colony Road, Chennai, Tamil Nadu - 600051</p>
         </div>
      </div>
   </div>
   <div class="wrapper wrapper-full-page">
      <div class="page-header register-page header-filter" filter-color="black"
         style="background-image: url('assets/images/group_1293.png')">
         <div class="container">
            <div class="row">
               <div class="col-md-7 ml-auto mr-auto">
                  <h1>Animal Disease<br>Monitoring System</h1>
               </div>
               <div class="col-md-5 ml-auto mr-auto">
                  <div class="card card-signup">
                     <h2 class="card-title text-center">Login</h2>
                     <div class="card-body">
                        <div class="row">
                           <div class="col-md-12 mr-auto">
                              <form class="form" (keydown)="keyDownFunction($event)" [formGroup]="registerForm">
                                 <div class="form-group has-default">
                                    <div class="input-group">
                                       <input type="email" id="email" class="form-control" formControlName="email"
                                          [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                                          placeholder="Email...">
                                       <div
                                          *ngIf="registerForm.get('email').invalid && (registerForm.get('email').touched)"
                                          class="invalid-feedback">
                                          <div class="selectvalidate" *ngIf="f.email.errors.required">Please enter a
                                             email address</div>
                                          <div class="selectvalidate" *ngIf="f.email.errors.email">Please enter a valid
                                             email address</div>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="form-group has-default">
                                    <div class="input-group">
                                       <input type="password" id="password" placeholder="Password..."
                                          formControlName="password" class="form-control"
                                          [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                       <div
                                          *ngIf="registerForm.get('password').invalid  && (registerForm.get('password').touched)"
                                          class="invalid-feedback">
                                          <div class="selectvalidate" *ngIf="f.password.errors.required">Please enter a
                                             password</div>
                                       </div>
                                    </div>
                                    <div *ngIf="submitted">
                                       <div *ngIf="invalidstatus==true" class="selectvalidate">Invalid username or
                                          password</div>
                                    </div>
                                 </div>
                                 <div class="form-group has-default text-right">
                                    <span style="cursor: pointer !important;color:#3a6dcd" data-target="#pwdModal" dat
                                       a-toggle="modal">Forgot password?</span>
                                 </div>
                                 <div class="form-group has-default text-center">
                                    <a (click)="onSubmit()" class="btn btn-primary">Submit</a>
                                 </div>
                              </form>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>


               <!--MODEL POPUP------------------------------------------------------------------>

               <div id="pwdModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
                  <div class="modal-dialog">
                     <div class="modal-content">
                        <div class="modal-header">
                           <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                           <h1 class="text-center" style="color: #0e0d0d;font-size: 41px;margin-top: 1rem;
                 margin-left: 69px;">Reset password</h1>
                        </div>
                        <div class="modal-body">
                           <div class="col-md-12">
                              <div class="panel panel-default">
                                 <div class="panel-body">
                                    <div class="text-center">
                                       <p style="color: black;
                                 position: relative;
                                 top: -20px;">Enter your email to reset your password</p>
                                       <form [formGroup]="registerFormval" (keydown)="keyDownFunctionsend($event)">
                                          <div class="panel-body">
                                             <fieldset>
                                                <div class="form-group">
                                                   <input class="form-control input-lg" id="emailreset"
                                                      placeholder="E-mail Address" name="emailreset" type="email"
                                                      (keyup)="removeverification()" formControlName="email1">
                                                   <div
                                                      *ngIf="registerFormval.get('email1').invalid && (registerFormval.get('email1').touched)">
                                                      <div class="selectvalidate"
                                                         *ngIf="registerFormval.get('email1').hasError('required')">
                                                         Please enter a email address</div>
                                                      <div class="selectvalidate"
                                                         *ngIf="registerFormval.get('email1').hasError('pattern')">
                                                         Please enter a valid email address</div>
                                                   </div>
                                                   <div *ngIf="invalid">
                                                      <div class="selectvalidate">{{errorverifyemail}}</div>
                                                   </div>
                                                </div>
                                                <input
                                                   style="height: 42px;line-height: 7px;background-color:#1d3f67;border:#1d3f67;"
                                                   class="btn btn-lg btn-primary btn-block" value="Reset password"
                                                   type="submit" (click)="submitresetemail()">
                                             </fieldset>
                                          </div>
                                       </form>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="modal-footer">
                           <div class="col-md-12">
                              <button class="btn btn-secondary float-right" style="color:black" data-dismiss="modal"
                                 aria-hidden="true">Cancel</button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</body>

</html>